<div
  class="bg-base-100/90 navbar sticky top-0 z-20 hidden items-center gap-2 px-4 py-0 backdrop-blur lg:flex "
>
  <a href="/" aria-current="page" aria-label="daisyUI" class="-ms-2 me-2 flex w-35 shrink-0 items-center gap-2">
<!--    <svg-icon src="./assets/icons/daisyUI_logo2.svg"></svg-icon>-->
    <svg-icon
      src="./assets/icons/lottie/wave-lines-still.svg"
      [svgClass]="''"
    ></svg-icon>
    <!--          <div class="w-35 h-18 text-base-content">-->
    <!--            <ng-lottie [options]="theme === 'light' ? options_light : options_dark" (animationCreated)="animationCreated($event)" />-->
    <!--          </div>-->
    <svg-icon
      src="./assets/icons/logo_analyzr_black.svg"
      [svgClass]="'absolute h-6 w-18 text-base-content p0 -ml-28 -mt-3'"
    ></svg-icon>
  </a>
  <app-drop-down [classMenu]="'absolute -ml-14'"></app-drop-down>
</div>
